// overview/* page translations
const overview = {
  enterpriseFactory: {
    v2: {
      breadcrumbRoot: 'Enterprise',
      refresh: 'Refresh',
      retry: 'Retry',
      loadFailed: 'Failed to load factory status',
      loading: 'Loading...',
      empty: 'No factories registered',
      unitMachine: '',
      unitCase: '',
      unitCount: '',
      level: {
        good: 'Normal',
        warn: 'Warning',
        bad: 'Critical',
      },
      status: {
        running: 'Running',
        idle: 'Idle',
        stopped: 'Stopped',
        partial: 'Partly stopped',
        none: 'No machines',
      },
      kpi: {
        equipment: 'Total machines',
        rate: 'Overall utilization',
        rateSub: 'Running {r} · Idle {i} · Stopped {s}',
        alarms: 'Total alarms',
        alarmSub: 'Critical {c} · Warning {w} · Info {i}',
        production: 'Total production (today)',
        productionSub: 'Unit: shots',
      },
      openFactory: 'Open factory status',
      runShare: 'Running share',
      legend: {
        running: 'Running',
        idle: 'Idle',
        stopped: 'Stopped',
      },
      rate: 'Utilization',
      equipment: 'Machines',
      openAlarms: 'Open alarms',
      machinesTitle: 'Machines',
      noMachines: 'No machines registered',
      moldNo: 'Mold No.',
      shotCount: 'Shot count',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      alarmCount: '{n} alarms',
      cycle: 'Cycle',
      alarmsTitle: 'Live Alarms',
      filter: {
        all: 'All',
        error: 'Critical',
        warning: 'Warning',
      },
      noAlarms: 'No active alarms.',
      repeat: '{n} times in 24h · {time}',
    },
  },
  factoryDefect: {
    breadcrumbRoot: 'Enterprise',
    pageLabel: 'Defect History',
    panelTitle: 'Factory defect history · {n} machines',
    refresh: 'Refresh',
    loadingData: 'Loading...',
    loadFailed: 'Failed to load defect history',
    factoryListLoadFailed: 'Failed to load factories',
    period: 'Period',
    periods: { today: 'Today', yesterday: 'Yesterday', last24h: 'Last 24 hours', last48h: 'Last 2 days' },
    source: 'Judged by',
    sources: { fusion: 'Fusion inspection', vision: 'Vision inspection', process: 'Process inspection' },
    equipment: 'Machine',
    type: 'Type',
    all: 'All',
    allEquipment: 'All machines',
    retentionNote: 'Shots and results are kept for 2 days',
    kpi: { inspected: 'Inspected', ng: 'Defects', ngRate: 'Defect rate', topType: 'Top type', topEquipment: 'Top machine' },
    countN: '{n}',
    matrixTitle: 'Machine × defect type',
    matrixSub: '{n} / {total} machines with results · click a cell to filter',
    trendTitleHour: 'Defects by hour',
    trendTitleDay: 'Defects by day',
    noTrend: 'No results for this period',
    listTitle: 'Defect list',
    rowHint: 'Open this machine’s Quality · Production screen',
    empty: 'No results for this period',
    emptyFiltered: 'No defects match the filter',
    colEquipment: 'Machine',
    colTotal: 'Total',
    colRate: 'Rate',
    colTime: 'Time',
    colMold: 'Mold',
    colShot: 'Shot',
    colType: 'Type',
    colProcess: 'Process score',
    colVision: 'Vision score',
    colFusion: 'Fusion score',
    colImage: 'Image',
    types: { FLASH: 'Flash', WELDLINE: 'Weld line', SHORT: 'Short shot', SINK: 'Sink mark', PROCESS: 'Process-caused', UNKNOWN: 'Other' },
    prev: 'Prev',
    next: 'Next',
  },
  factoryMachine: {
    breadcrumbRoot: 'Enterprise',
    pageLabel: 'Machine Status',
    panelTitle: 'Machines in factory · {n}',
    cards: {
      line: 'Line',
      state: 'Status',
      sort: 'Sort',
      alarmOnly: 'Alarm',
      moldNo: 'Mold No.',
      shotCount: 'Shot count',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      utilization: 'Utilization',
      cycleTime: 'Cycle',
      alarmCount: '{n} alarms',
      sort_utilization: 'Utilization↓',
      sort_number: 'Number',
      sort_shot: 'Shot count↓',
      sort_alarm: 'Alarms first',
    },
    title: 'Machine Dashboard',
    subtitle: 'Injection machine status in the factory',
    update: 'Updated',
    loading: 'Loading...',
    loadingData: 'Loading data...',
    loadFailed: 'Failed to load data.',
    factoryListLoadFailed: 'Failed to load factory list.',
    refresh: 'Refresh',
    emptyMachines: 'No machines registered.',
    selectFactory: 'Select a factory',
    all: 'All',
    machine: {
      productName: 'Product',
      shotCount: 'Shot Count',
      cavityCount: 'Cavities',
      cycleTime: 'Cycle Time',
      utilizationLabel: '24h Utilization',
      timelineTitle: '24h Operation Status',
      cavityUnit: '{n}',
      cycleTimeUnit: '{n}s',
      empty: '-',
    },
    legend: {
      operating: 'Running',
      standby: 'Standby',
      stopped: 'Stopped',
    },
    status: {
      running: 'Running',
      idle: 'Standby',
      stopped: 'Stopped',
      error: 'Error',
    },
  },
};
export default overview;
